// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1So6A","question":"styles_question__1SgA2","inputVisibleButton":"styles_inputVisibleButton__3E_-Y","note":"styles_note___Dy7s"};